import { connectMonthServiceList } from './connectMonthServiceList';
import { MonthServiceList as MonthServiceListPure } from './MonthServiceList';

export const MonthServiceList = connectMonthServiceList(MonthServiceListPure);
